import React from 'react';

export default function GamifiedButton({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = '',
  ...rest
}) {
  // Base styles
  const baseStyles = "relative border-none rounded-lg font-semibold cursor-pointer transition-all duration-300 overflow-hidden font-['Poppins'] uppercase tracking-wide shadow-md";

  // Variant styles
  const variantStyles = {
    primary: "bg-gradient-to-br from-[#4AA294] to-[#2F7E72] text-white shadow-[0_4px_15px_rgba(139,111,71,0.3)] hover:shadow-[0_6px_25px_rgba(139,111,71,0.5)] hover:-translate-y-0.5",
    secondary: "bg-gradient-to-br from-[#A8D5BA] to-[#7FBE9E] text-white shadow-[0_4px_15px_rgba(139,111,71,0.2)] hover:bg-gradient-to-br hover:from-[#8FCAA8] hover:to-[#6BA889] hover:shadow-[0_6px_25px_rgba(139,111,71,0.4)] hover:-translate-y-0.5"
  };

  // Size styles
  const sizeStyles = {
    sm: "px-4 py-2 text-xs",
    md: "px-8 py-3 text-sm",
    lg: "px-12 py-4 text-base"
  };

  // Disabled styles
  const disabledStyles = disabled ? "opacity-60 cursor-not-allowed !transform-none !shadow-none" : "active:translate-y-0";

  return (
    <button
      {...rest}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${disabledStyles} ${className} group`}
      aria-disabled={disabled}
    >
      <span className="relative z-10 flex items-center gap-2">{children}</span>
      <span className="absolute top-0 left-0 w-full h-full rounded-[inherit] pointer-events-none opacity-0 group-hover:opacity-100 group-hover:animate-[glow-pulse-soft_1.5s_infinite] bg-[radial-gradient(circle,rgba(255,255,255,0.2)_0%,transparent_70%)] transition-opacity duration-300"></span>

      {/* Keyframes for glow animation */}
      <style>{`
        @keyframes glow-pulse-soft {
          0%, 100% {
            opacity: 0.6;
            box-shadow: 0 0 10px rgba(255, 255, 255, 0.3);
          }
          50% {
            opacity: 1;
            box-shadow: 0 0 20px rgba(255, 255, 255, 0.5);
          }
        }
      `}</style>
    </button>
  );
}
